module.exports = __webpack_public_path__ + "img/1x.fdb4c59.jpg";